import Vue from 'vue';
import VueRouter from 'vue-router';
import VehiclePreassignment from '@/components/VehiclePreassignment';
import SubscriptionEnd from '@/components/SubscriptionEnd';

import Routes from '@/components/Routes';

import RouteBuilder from '@/components/RouteBuilder';
import TripBuilder from '@/components/TripBuilder';
import ActivityBuilder from '@/components/ActivityBuilder';

import RouteAssignment from '@/components/RouteAssignment';
import RouteFulfillment from '@/components/RouteFulfillment';
import MotivesAndSubmotives from '@/components/MotivesAndSubmotives';
import RouteEvents from '@/components/RouteEvents';
import RouteBoard from '@/components/RouteBoard';
import SecureMode from '@/components/SecureMode';
import ClientConfiguration from '@/components/ClientConfiguration';
import Configurations from '@/components/Configurations';
import Operations from '@/components/Operations';
import QueryBuilder from '@/components/QueryBuilder';
import Planification from '@/components/Planification';
import TrackingPlanification from '@/components/TrackingPlanification';
import OperationProcess from '@/components/OperationProcess';
import DateAndDepotProcess from '@/components/DateAndDepotProcess';
import ResourceProcess from '@/components/ResourceProcess';
import RouteProcess from '@/components/RouteProcess';
import Tags from '@/components/Tags';
import Vehicle from '@/components/Vehicle';
import ConfigAssignation from '@/components/ConfigAssignation';
import User from '@/components/User';
import Spots from '@/components/Spots';
import Sender from '@/components/Sender';
import GeoFence from '@/components/GeoFence';
import WebNotification from '@/components/WebNotification';
import GPSEvaluationTime from '@/components/GPSEvaluationTime';
import AppMobile from '@/components/AppMobile';
import Cfdi from '@/components/Cfdi';

import PrivacyPolicy from '@/misc/privacyPolicy/PrivacyPolicy';

import Report from '@/components/Report';

import Template from '@/components/Template';

import Indicator from '@/components/Indicator';

import BusinessIntelligence from '@/components/BusinessIntelligence';

import Integrations from '@/components/Integrations';

Vue.use(VueRouter);

const routes = [
  {
    path: '/notAllowed',
    name: 'SubscriptionEnd',
    component: SubscriptionEnd,
  },
  {
    path: '/indicatorV2',
    name: 'BusinessIntelligence',
    component: BusinessIntelligence,
  },
  {
    path: '/routes',
    name: 'Routes',
    component: Routes,
  },
  {
    path: '/routeBuilder/:routeId?',
    name: 'RouteBuilder',
    component: RouteBuilder,
    props: true,
  },
  {
    path: '/tripBuilder/:tripId',
    name: 'TripBuilder',
    component: TripBuilder,
    props: true,
  },
  {
    path: '/tripBuilder',
    name: 'TripBuilderNotId',
    component: TripBuilder,
    props: true,
  },
  {
    path: '/activityBuilder/:activityId?',
    name: 'ActivityBuilder',
    component: ActivityBuilder,
    props: true,
  },
  {
    path: '/clientConfiguration',
    name: 'ClientConfiguration',
    component: ClientConfiguration,
  },

  {
    path: '/appMobile',
    name: 'AppMobile',
    component: AppMobile,
  },
  {
    path: '/configurations',
    name: 'Configurations',
    component: Configurations,
  },

  {
    path: '/configAssignation',
    name: 'ConfigAssignation',
    component: ConfigAssignation,
  },

  {
    path: '/webNotification',
    name: 'WebNotification',
    component: WebNotification,
  },

  {
    path: '/tags',
    name: 'Tags',
    component: Tags,
  },
  
  {
    path: '/geoFence',
    name: 'GeoFence',
    component: GeoFence,
  },

  {
    path: '/gpsevaluationtime',
    name: 'GPSEvaluationTime',
    component: GPSEvaluationTime,
  },

  {
    path: '/secureMode',
    name: 'SecureMode',
    component: SecureMode,
  },
  {
    path: '/vehiclePreassignment',
    name: 'Vehicle Preassignment',
    component: VehiclePreassignment,
  },
  {
    path: '/routeAssignment',
    name: 'RouteAssignment',
    component: RouteAssignment,
  },
  {
    path: '/routeFulfillment',
    name: 'Route fulfillment',
    component: RouteFulfillment,
  },
  {
    path: '/motivesAndSubmotives',
    name: 'Motives and submotives',
    component: MotivesAndSubmotives,
  },
  {
    path: '/routeEvents',
    name: 'Route events',
    component: RouteEvents,
  },
  {
    path: '/',
    name: 'RouteBoard',
    component: RouteBoard,
  },
  {
    path: '/basicPlan',
    name: 'Planification',
    component: Planification,
  },
  {
    path: '/tracking',
    name: 'TrackingPlanification',
    component: TrackingPlanification,
  },
  {
    path: '/operations',
    name: 'Operations',
    component: Operations,
  },
  {
    path: '/queryBuilder',
    name: 'QueryBuilder',
    component: QueryBuilder,
  },
  {
    path: '/planificationBuilder/OperationUpload',
    name: 'OperationProcessNotOngoing',
    component: OperationProcess,
    props: true,
  },
  {
    path: '/planificationBuilder/OperationUpload/:planificationId',
    name: 'OperationProcess',
    component: OperationProcess,
    props: true,
  },
  {
    path: '/planificationBuilder/DateAndDepotSelection',
    name: 'DateAndDepotProcessNotOngoing',
    component: DateAndDepotProcess,
    props: true,
  },
  {
    path: '/planificationBuilder/DateAndDepotSelection/:planificationId',
    name: 'DateAndDepotProcess',
    component: DateAndDepotProcess,
    props: true,
  },
  {
    path: '/planificationBuilder/ResourceSelectionProcess',
    name: 'ResourceProcessNotOngoing',
    component: ResourceProcess,
    props: true,
  },
  {
    path: '/planificationBuilder/ResourceSelectionProcess/:planificationId',
    name: 'ResourceProcess',
    component: ResourceProcess,
    props: true,
  },
  {
    path: '/planificationBuilder/RouteProcess',
    name: 'RouteProcessNotOngoing',
    component: RouteProcess,
    props: true,
  },
  {
    path: '/planificationBuilder/RouteProcess/:planificationId',
    name: 'RouteProcess',
    component: RouteProcess,
    props: true,
  },
  {
    path: '/vehicle',
    name: 'Vehicle',
    component: Vehicle,
  },
  {
    path: '/user',
    name: 'User',
    component: User,
  },
  {
    path: '/spot',
    name: 'Spots',
    component: Spots,
  },
  {
    path: '/sender',
    name: 'Sender',
    component: Sender,
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
  },
  {
    path: '/cfdi',
    name: 'Cfdi',
    component: Cfdi,
  },
  {
    path: '/report',
    name: 'Report',
    component: Report,
  },
  {
    path: '/template',
    name: 'Template',
    component: Template,
  },
  {
    path: '/indicator',
    name: 'Indicator',
    component: Indicator,
  },
  {
    path: '/integrations',
    name: 'Integrations',
    component: Integrations,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
